<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button [label]="'common.new' | transloco" pButton pRipple class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new" icon="pi pi-plus"></button>
            </div>
            <div class="flex flex-column md:flex-row justify-content-end">
              <button (click)="filtersVisible = !filtersVisible" class="p-button-secondary" icon="pi pi-sliders-h"
                label=" {{'common.filters' | transloco}}" pButton></button>
            </div>
          </div>
        </div>
        <p-table (onLazyLoad)="onPageChange($event)" [(first)]="first" [(rows)]="rows" [lazy]="true" [paginator]="true"
          [responsive]="true" responsiveLayout="stack" breakpoint="1600px" [rowsPerPageOptions]="[10,25,50]"
          [totalRecords]="totalUsers" [value]="users" sortField="name" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col"></th>
              <th scope="col">{{'attribute.firstName' | transloco}}</th>
              <th scope="col">{{'attribute.lastName' | transloco}}</th>
              <th scope="col">{{'attribute.username' | transloco}}</th>
              <th scope="col">{{'model.profile' | transloco}}</th>
              <th scope="col">{{'attribute.email' | transloco}}</th>
              <th scope="col">{{'attribute.phone' | transloco}}</th>
              <th scope="col">{{'model.organization' | transloco}}</th>
              <th scope="col" class="w-10rem"></th>
            </tr>
          </ng-template>
          <ng-template let-user pTemplate="body">
            <tr *ngIf="!loadingUsers">
              <td>
                <span class="p-column-title bold">{{'attribute.eCommerceUser' | transloco}}</span>
                <p-tag *ngIf="user.eCommerceUser" class="list-tag" value="{{'attribute.eCommerce' | transloco}}"></p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.firstName' | transloco}}</span>
                {{user.firstName}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.lastName' | transloco}}</span>
                {{user.lastName}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.username' | transloco}}</span>
                {{user.username}}
              </td>
              <td>
                <span class="p-column-title bold">{{'model.profile' | transloco}}</span>
                <p-tag *ngIf="user.profile" class="list-tag" value="{{user.profile.name}}"></p-tag>
                <p-tag *ngIf="!user.profile" class="tag-warning" value="{{'model.noProfile' | transloco}}"></p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.email' | transloco}}</span>
                {{user.email}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.phone' | transloco}}</span>
                {{user.phone}}
              </td>
              <td>
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                {{user.organization.name}} ({{user.organization.orgCode}})
              </td>
              <td>
                <span class="p-column-title bold"></span>
                <div class="flex justify-content-end">
                  <button *ngIf="user.role !== 'SUPER_ADMIN'" [disabled]="" [routerLink]="user.userUuid + '/groups'"
                    class="p-button-rounded btn-primary-light mr-2" icon="pi pi-tags" pButton pRipple></button>
                  <button *ngIf="user.role !== 'SUPER_ADMIN'" [disabled]="" [routerLink]="user.userUuid + '/edit'"
                    class="p-button-rounded btn-primary-light mr-2" icon="pi pi-pencil" pButton pRipple></button>
                  <button (click)="confirmAndDelete(user)" *ngIf="user.role !== 'SUPER_ADMIN'"
                    class="p-button-rounded btn-danger-light" icon="pi pi-trash" pButton pRipple></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingUsers">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalUsers == 0" class="flex align-items-center justify-content-between">{{'pagination.empty' |
              transloco}}</div>
            <div *ngIf="totalUsers > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalUsers ? totalUsers : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalUsers}}
              {{(totalUsers > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="firstName">{{'attribute.firstName' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.firstName"
          [focus]="filtersVisible" appAutoFocus class="w-full" id="firstName" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="lastName">{{'attribute.lastName' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.lastName"
          class="w-full" id="lastName" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="username">{{'attribute.username' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.username"
          class="w-full" id="username" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="email">{{'attribute.email' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.email" class="w-full"
          id="email" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="phone">{{'attribute.phone' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.phone" class="w-full"
          id="phone" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="organization">{{'model.organization' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                      [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
                      [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization"></p-treeSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="profile">{{'model.profile' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect [(ngModel)]="currentFilters.profileUuids" [placeholder]="'select.generic' | transloco"
                       [options]="profiles" [filter]="true" filterBy="name" display="chip" appendTo="body" styleClass="w-full"
                       optionLabel="name" optionValue="profileUuid" id="profile"></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="userType">{{'attribute.userType' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown [placeholder]="'select.generic' | transloco" styleClass="w-full" appendTo="body" [showClear]="true"
                    [options]="this.userTypeOptions" id="userType" [(ngModel)]="this.currentFilters.userType" optionLabel="label" optionValue="value">
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <p-button (onClick)="filtersVisible = false; applyFilters()" [disabled]="!(currentFilters.firstName ||
                currentFilters.lastName ||
                currentFilters.username ||
                currentFilters.profileUuids ||
                currentFilters.email ||
                currentFilters.phone ||
                currentFilters.userType ||
                organizations)" label="{{'common.filter' | transloco}}" styleClass="p-button-primary mx-2 mt-2"
        type="button"></p-button>
      <p-button (click)="resetFilters(); filtersVisible = false; applyFilters()" label="{{'common.clear' | transloco}}"
        styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>
